<script>
export default {
  name: "PortalMerchantDetailCard",
  props: { invoice: { type: Object, default: () => ({}) } },
  emits: [],
  data() {
    return {
      company: window.FinancialCents.company || null,
    }
  },
}
</script>

<template>
  <div class="mx-auto rounded p-6 bg-white border sm:h-full md:h-auto">
    <div class="font-bold text-gray-800">Merchant details</div>
    <div class="mt-3 text-gray-700">
      {{ company.billing.email || invoice.representative?.email }}
    </div>
    <div
      class="whitespace-pre-wrap mt-2 text-gray-700"
      v-if="company.billing.address"
    >
      {{ company.billing.address }}
    </div>
  </div>
</template>

<style scoped></style>
